import getMutation from './get-mutation/'
import getVariables from './get-variables/'
// import getUpdate from './get-update/'
import getOptimisticResponse from './get-optimistic-response/'
import { getClient } from '..'

export default async ({ root, ids: _ids, parents, where }) => {
  const ids = _ids
    ? Array.isArray(_ids)
      ? _ids
      : [_ids]
    : []

  const client = getClient()
  const mutation = getMutation({ root })
  const variables = getVariables(({ ids, where }))
  const optimisticResponse = getOptimisticResponse({ root, ids })
  // const update = getUpdate({ root, fields, request })

  // state.result = processRequest({
  //   items: items
  //     ? state.result.filter(({ id }) => !items.find(item => item.id === id))
  //     : [],
  //   request
  // })

  return client.mutate({
    mutation,
    variables,
    optimisticResponse,
    update (cache) {
      parents.forEach(({ root: parentRoot, id: parentId, field }) => {
        cache.modify({
          ...parentId
            ? ({
              id: `${parentRoot}:${parentId}`
            }) : null,
          fields: {
            [field || root]: (items, { readField }) =>
              items.filter(
                item => !ids.some(id => readField('id', item) === id)
              )
          }
        })
      })
      ids.forEach((id, i) => {
        cache.evict({
          id: `${root}:${id}`
        })
      })
    }
  })
}
